











































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import * as rules from '@/rules';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import { NotificationEventBus } from '@/EventBus';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import _ from 'lodash';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { ViewpointChoiceFactor } from '@/api/model/ViewpointChoiceFactor';
import { ViewpointFactorResource } from '@/api/model/ViewpointFactorResource';
import ListInputDialog from '@/components/forms/ListInputDialog.vue';
import { Viewpoint } from '@/api/model/Viewpoint';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import moment from 'moment';
import ViewpointListSelection from  "@/components/Lists/ViewpointListSelection.vue"
import ViewpointListInputDialog from  "@/components/Lists/ViewpointListInputDialog.vue"
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ViewpointCreatorButton from '@/views/Viewpoint/ViewpointCreatorButton.vue';
import Apps from '@/store/modules/Apps';
import CopyResourcesDialog from '@/components/common/CopyResourcesDialog.vue';

const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const WorkspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);

@Component({
    components: { 
        DescriptionEditor,
        CardTitle,
        ListInputDialog,
        BasicInputForm,
        ViewpointListSelection,
        ViewpointListInputDialog,
        ConfirmationDialog,
        ViewpointCreatorButton,
        CopyResourcesDialog
    },
})
export default class ViewpointCreator extends Vue {
    private createViewpointDialog = false;
    private editViewpointDialog = false;
    private generateViewpointDialog = false;
    private cloneViewpointDialog = false;
    private adding = false;
    private formViewpoint = {};
    private originalViewpoint: any = {};
    private refreshing = false;
    private addToList = true;
    private requiredRule = [rules.REQUIRED];
    private selectedVariation = '';
    private selectedViewpoints = [];
    private showSearch = true;
    private search = "";
    private generationOptions = [
        'None',
        'Include Scores',
        'Include Slope',
        'Just Scores',
        'Scores to Ranks',
        'Weights to 3 bins quantile',
        'Decision Tree Weights',
    ];
    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }
    
    get isAdminOrOwner(): boolean {
        return decisionsModule.isAdmin || decisionsModule.isOwner;
    }

    get allowGenerateViewpoints() {
        return WorkspaceOptionsModule.allowGenerateViewpoints;
    }

    set allowGenerateViewpoints(val: boolean) {
        WorkspaceOptionsModule.setAllowGenerateViewpoints(val);
    }

    get isDecisionOwner() {
        if (this.selectedDecision) {
            return this.currentUserId === this.selectedDecision.ownerUserId;
        }
    }

    get currentUserId() {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
    }

    get activeItems(): any[] {
        if (this.activeViewpointId) {
            return [{ viewpointId: this.activeViewpointId }];
        }
        return [];
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId;
    }

    get headers() {
        return [
            {
                text: '',
                value: 'actions',
                sortable: false,
                width: 24,
            },
            {
                text: this.singularViewpointLabel,
                value: 'name',
                width: '25%',
            },
            {
                text: 'Description',
                value: 'description',
                width: '50%',
            },
            {
                text: 'Updated',
                value: 'lastUpdatedTimestamp',
                width: 120,
            },
            {
                text: 'Create',
                value: 'creationTimestamp',
                width: 120,
            },
            {
                text: 'Owner',
                value: 'ownerUserId',
                width: 150,
            },
        ];
    }

    get activeViewpointList() {
        return WorkspaceOptionsModule.activeViewpointLists;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get viewpointList(): Viewpoint[] {
        return viewpointsModule.decisionViewpoints || [];
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }
    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get decisionViewpoints() {
        return viewpointsModule.decisionViewpoints;
    }

    get viewpointsMap() {
        return viewpointsModule.decisionViewpointsMap;
    }

     get decisionLists() {
        return decisionsModule.decisionLists;
    }

    get userId(): string {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return '[user]';
    }

    get userList() {
        return decisionsModule.selectedDecisionUsers;
    }

    private editViewpointClick(viewpoint: Viewpoint) {
        this.formViewpoint = viewpoint;
        this.editViewpointDialog = true;
    }

    // Create Viewpoint(s) from a List
    private async createViewpointsFromList(payload: any) {
        let list = payload.names;
        let addToList = payload.addToList;
        let results = [];
        this.refreshing = true;
        if (list.length) {
            let viewpoints = list
                .filter((l) => l)
                .map((name) => {
                    return {
                        name: name,
                        addToList: addToList,
                    };
                });
            viewpoints.forEach((v: any) => {
                this.createViewpoint(v);
            });
        }
        this.refreshing = false;
    }
    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description,
            });
            if (sampleViewpoint.addToList && this.activeViewpointList?.length > 0 && this.addToList) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        // console.log(viewpoint);
        this.adding = false;
    }
    private isUserAllowedToDelete(viewpoint: any) {
        let userRole = this.userList[this.userId]?.permissionAccess;
        let viewpointUserId = viewpoint.ownerUserId;
        let viewpointUserRole = this.userList[viewpointUserId]?.permissionAccess;
        switch (userRole) {
            case 'OWNER':
                return true;
                break;
            case 'ADMIN':
                //Don't allow deletion of viewpoints when viewpoint is owned by owner or other admin
                if (
                    viewpointUserId != this.userId &&
                    (viewpointUserRole === 'OWNER' || viewpointUserRole === 'ADMIN')
                ) {
                    return false;
                } else {
                    return true;
                }
                break;
            case 'EDIT':
                if (viewpointUserId === this.userId) {
                    return true;
                } else {
                    return false;
                }
                break;
            default:
                return false;
        }
    }

    private async generateViewpoint(payload: any) {
        NotificationEventBus.emitProcessingMessage();
        this.generateViewpointDialog = false;
        try{
            await viewpointsModule.generateViewpoint(payload)
           NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    @Watch('showSearch')
    private onChangeShowSearch() {
        this.search = "";
    }

    @Watch('activeViewpointList')
    private onChangeActiveViewpointLists() {
        this.selectedViewpoints = [];
    }
    
    private async editViewpoint(payload: Viewpoint) {
        this.editViewpointDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateViewpoint(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async cloneViewpoint(payload: any) {
        this.cloneViewpointDialog = false;
        if (!this.selectedDecision) return;
        NotificationEventBus.emitProcessingMessage();
        let original: Viewpoint = _.cloneDeep(this.originalViewpoint);
        let newParams = _.cloneDeep(payload);
        try {
            await viewpointsModule.cloneViewpoint({ original: original, newViewpoint: newParams, includeWeights: true, includeKeys: true, includeScores: true });
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private formatDate(dateString: string) {
        return moment(dateString).format('YYYY-MM-DD');
    }

    private getUserNameFromId(userId: string) {
        let user = decisionsModule.selectedDecisionUsers[userId];
        // console.log(user, userId);
        if(user){
            return user.first || user.last ? user.first + ' ' + user.last : user.email;
        } else{
            return 'Guest'
        }
    }

    private async refresh() {
        this.refreshing = true;
        await decisionsModule.getDecisionViewpoints(this.selectedDecision.decisionId);
        this.refreshing = false;
    }

    private async addToLists(payload: string[]) {
        console.log(payload)
        await decisionsModule.addViewpointsToSelectLists({viewpoints: this.selectedViewpoints, listIds: payload})
    }

    private async removeFromLists(payload: string[]) {
        console.log(payload)
        await decisionsModule.removeViewpointsFromSelectLists({viewpoints: this.selectedViewpoints, listIds: payload})
    }

    private loadSelection(payload: string[]) {
        let viewpointsInList: Viewpoint[] = [];
        for(let listId of payload) {
            if(this.decisionLists[listId].type === 'VIEWPOINT') {
                for(let viewpoint of this.decisionLists[listId].viewpoints) {
                    if( viewpoint.viewpointId in this.viewpointsMap && !viewpointsInList.includes(this.viewpointsMap[viewpoint.viewpointId]) ) {
                        viewpointsInList.push(this.viewpointsMap[viewpoint.viewpointId]);
                    }
                }
            }
        }
        this.selectedViewpoints =  viewpointsInList;
    }

    private async deleteMultiple() {
        this.refreshing = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            if(this.selectedViewpoints.length > 0) {
                await decisionsModule.deleteMultipleViewpoints(this.selectedViewpoints)

                if(WorkspaceOptionsModule.activeViewpointLists.length > 0) {
                    await decisionsModule.deleteViewpointFromList()
                }
            }
            NotificationEventBus.emitSuccessMessage();
        }
        catch(e) {
            NotificationEventBus.emitFailedMessage(e);
        }
        this.selectedViewpoints = [];
        this.refreshing = false
        return
    
    }

    private async copyViewpoints(payload: any) {
        this.refreshing = true;
        for(let viewpoint of Object.keys(payload)) {
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload[viewpoint] ? payload[viewpoint] : `Copy of ${this.viewpointsMap[viewpoint].name}`,
                description: this.viewpointsMap[viewpoint].description,
                addToList: this.addToList
            }
            await viewpointsModule.cloneViewpoint({original: this.viewpointsMap[viewpoint], newViewpoint: newVp, includeWeights: true, includeKeys: true, includeScores: true})
        }
        this.selectedViewpoints = [];
        this.refreshing = false;
    }
}
